import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import Main from './Main';
import RSVPAdmin from './RSVPAdmin';
import { bindActionCreators } from 'redux';
import './App.css';

const mapStateToProps = state => ({});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

class App extends Component {
  render() {
    return (
      <div id="App" className="App">
        <Route path="/admin/rsvp" component={RSVPAdmin} />
        <Route path="/" component={Main} />
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js